/**
 * @generated SignedSource<<eb55446a0d01ed6665dd6598c68ade97>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FilterActions$data = {
  readonly __typename: string;
  readonly filterId: string;
  readonly id: string;
  readonly isEditable?: boolean | null;
  readonly isFavourite: boolean | null;
  readonly name: string;
  readonly owner?: {
    readonly accountId: string;
  } | null;
  readonly " $fragmentType": "Nav4FilterActions";
};
export type Nav4FilterActions$key = {
  readonly " $data"?: Nav4FilterActions$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterActions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4FilterActions",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "filterId"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            }
          ]
        }
      ],
      "type": "JiraCustomFilter"
    }
  ],
  "type": "JiraFilter",
  "abstractKey": "__isJiraFilter"
};

(node as any).hash = "fc1df3dea8f781b871d9be816b6279fc";

export default node;
